import { IHistory, IForms } from '../../../interfaces';
import { ListPage } from '../../reusableComponents/ListPage'; 
import * as React from 'react'; 
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';  
import { BasePage } from '../../reusableComponents/BasePage'; 
import { ListItem } from './ListItem';
import { Async } from '../../reusableComponents/Async';
import { ErrorPage } from '../../reusableComponents/ErrorPage';
import { Loader } from '../../reusableComponents/Loader'; 
import { DeleteConfirmationModal } from '../../reusableComponents/DeleteConfirmationModal'; 
import { AlertModal } from '../../reusableComponents/ModalComponents/AlertModal'; 
import { getAllDesignations } from '../../../services/miscellaniousServices'; 
import { setLoading, setSuccess } from '../../../actions/loadingActions'; 
import { IDesignationModelProps, DesignationModel } from '../../../model/MiscellaneousModel';
import { UserModel } from '../../../model/UserModel';
declare var require: any;
const queryString = require('query-string');

export interface IDesignationListPageProps {
    instance: IDesignationModelProps[];
    history?: IHistory;
    match?: {
        params: {
            id: string;
        }
    }; 
    forms: IForms;
    userUID: string;
}

export interface IDesignationListPageState {
    showDetails: boolean;
    formId: string;
}

export class DesignationListPageImpl extends React.PureComponent<IDesignationListPageProps, IDesignationListPageState> {
    constructor(props: IDesignationListPageProps | Readonly<IDesignationListPageProps>) {
        super(props);
        this.state = { showDetails: false, formId: '' };
    }

    promise = async () => { 
        await this.getReportData();
    }

    getReportData = async () => {
        setLoading('AllListPage');   
        await getAllDesignations();
        setSuccess('AllListPage'); 
    }
    renderFormList = () => {
        const { instance } = this.props; 
        return (
            <>  
                <div className="jsa-list-wrapper"> 
                    <ListPage
                        pageHeading={'Designations'}
                        instances={instance}
                        rowHeadings={['Designation', 'Status' ]}
                        listItemComponent={ListItem}
                        emptyInstancesMessage="No designation found."
                        isSearchable={false}
                        searchableBy={['designation' ]}
                        searchPlaceHolder="Enter designation to search..."
                        sm={[5, 2]}
                        currentPage={queryString.parse(this.props.history?.location['search']).pageNumber || 1}
                    />  
                    { UserModel.checkUserAccess('group_add') && this.renderAddGroupButton() }
                </div> 
            </>
        );
    } 
    renderAddGroupButton = () => {  
        return (<button className="add-new-report"
            onClick={() => { this.props.history?.push('/designation/create'); }}
        >
            +
        </button>);
    }

    render() {
        return (
            <BasePage className="min-wide-list-page" > 
                <DeleteConfirmationModal id="delete-confirmation" />
                <AlertModal id="delete-success" />
                <Async
                    identifier="LocationListPage"
                    promise={this.promise}
                    error={<ErrorPage />}
                    loader={<Loader />}
                    content={ this.renderFormList()}
                />; 
            </BasePage >
        );
    }
}

export function mapStateToProps(state: any) {  
    const instance =  DesignationModel.list(); 
    let userUID = state.login.get('userUID');
    return { instance, forms: state.forms, userUID, };
}

export const DesignationListPage = withRouter(connect< IDesignationListPageProps, any, any>(mapStateToProps)(DesignationListPageImpl));
